import { Dialog } from '@/components/ui/dialog'

import ClientAreaAuditLog, { ClientAreaAuditLogProps } from './ClientAreaAuditLog'

interface ClientAreaAuditLogModalProps extends ClientAreaAuditLogProps {
  isVisible: boolean
  onClose: () => void
}

const ClientAreaAuditLogModal = ({
  isVisible,
  onClose,
  ...auditLogProps
}: ClientAreaAuditLogModalProps) => {
  return (
    <Dialog open={isVisible} onOpenChange={onClose}>
      <ClientAreaAuditLog {...auditLogProps} />
    </Dialog>
  )
}

export default ClientAreaAuditLogModal
